import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="application"
// Global application controller that handles browser navigation events and URL management
// Should be connected to the body element to persist across page loads
export default class extends Controller {
  static values = {
    pushStateDelay: { type: Number, default: 300 },
  };

  connect() {
    this.boundHandlePopState = this.handlePopState.bind(this);
    this.boundHandlePushState = this.handlePushState.bind(this);
    this.pushStateTimeout = null;

    // Listen for back/forward navigation globally
    window.addEventListener("popstate", this.boundHandlePopState);

    // Listen for push state requests from other controllers
    document.addEventListener("application:push-state", this.boundHandlePushState);
  }

  disconnect() {
    // Clean up event listeners
    window.removeEventListener("popstate", this.boundHandlePopState);
    document.removeEventListener("application:push-state", this.boundHandlePushState);
    this.clearPushStateTimeout();
  }

  // Handle back/forward navigation
  handlePopState(event) {
    // Use Turbo to navigate to the current URL
    Turbo.visit(window.location.href, { action: "replace" });
  }

  // Handle push state requests from other controllers
  handlePushState(event) {
    const { form, baseUrl, delay } = event.detail;

    this.clearPushStateTimeout();
    this.pushStateTimeout = setTimeout(() => {
      this.pushState(form, baseUrl);
    }, delay || this.pushStateDelayValue);
  }

  // Push state to browser history
  pushState(form, baseUrl) {
    // Collect all form data
    const formData = new FormData(form);
    const searchParams = new URLSearchParams(formData);

    // Build the complete URL with form parameters
    const fullUrl = searchParams.toString() ? `${baseUrl}?${searchParams.toString()}` : baseUrl;

    history.pushState(null, "", fullUrl);
  }

  clearPushStateTimeout() {
    if (this.pushStateTimeout) {
      clearTimeout(this.pushStateTimeout);
      this.pushStateTimeout = null;
    }
  }
}
